const descriptions = {
  tabTitleLabel: {
    id: 'course-authoring.textbooks.form.tab-title.label',
    defaultMessage: 'Textbook name',
    description: 'Label for the textbook name field in the form',
  },
  tabTitlePlaceholder: {
    id: 'course-authoring.textbooks.form.tab-title.placeholder',
    defaultMessage: 'Introduction to Cookie Baking',
    description: 'Placeholder text for the textbook name field in the form',
  },
  tabTitleHelperText: {
    id: 'course-authoring.textbooks.form.tab-title.helper-text',
    defaultMessage: 'provide the title/name of the textbook as you would like your students to see it',
    description: 'Helper text for the textbook name field in the form',
  },
  tabTitleValidationText: {
    id: 'course-authoring.textbooks.form.tab-title.validation-text',
    defaultMessage: 'Textbook name is required',
    description: 'Validation error message for the textbook name field in the form',
  },
  chapterTitleLabel: {
    id: 'course-authoring.textbooks.form.chapter.title.label',
    defaultMessage: 'Chapter name',
    description: 'Label for the chapter name field in the form',
  },
  chapterTitlePlaceholder: {
    id: 'course-authoring.textbooks.form.chapter.title.placeholder',
    defaultMessage: 'Chapter {value}',
    description: 'Placeholder text for the chapter name field in the form',
  },
  chapterTitleHelperText: {
    id: 'course-authoring.textbooks.form.chapter.title.helper-text',
    defaultMessage: 'provide the title/name of the chapter that will be used in navigating',
    description: 'Helper text for the chapter name field in the form',
  },
  chapterTitleValidationText: {
    id: 'course-authoring.textbooks.form.chapter.title.validation-text',
    defaultMessage: 'Chapter name is required',
    description: 'Validation error message for the chapter name field in the form',
  },
  chapterUrlLabel: {
    id: 'course-authoring.textbooks.form.chapter.url.label',
    defaultMessage: 'Chapter asset',
    description: 'Label for the chapter asset field in the form',
  },
  chapterUrlPlaceholder: {
    id: 'course-authoring.textbooks.form.chapter.url.placeholder',
    defaultMessage: 'path/to/introductionToCookieBaking-CH1.pdf',
    description: 'Placeholder text for the chapter asset field in the form',
  },
  chapterUrlHelperText: {
    id: 'course-authoring.textbooks.form.chapter.url.helper-text',
    defaultMessage: 'upload a PDF file or provide the path to a Studio asset file',
    description: 'Helper text for the chapter asset field in the form',
  },
  chapterUrlValidationText: {
    id: 'course-authoring.textbooks.form.chapter.url.validation-text',
    defaultMessage: 'Chapter asset is required',
    description: 'Validation error message for the chapter asset field in the form',
  },
  addChapterHelperText: {
    id: 'course-authoring.textbooks.form.add-chapter.helper-text',
    defaultMessage: 'Please add at least one chapter',
    description: 'Helper text for adding a new chapter in the form',
  },
  addChapterButton: {
    id: 'course-authoring.textbooks.form.add-chapter.button',
    defaultMessage: 'Add a chapter',
    description: 'Text for the button to add a new chapter in the form',
  },
  uploadButtonTooltip: {
    id: 'course-authoring.textbooks.form.upload-button.tooltip',
    defaultMessage: 'Upload',
    description: 'Tooltip text for the upload button in the form',
  },
  uploadButtonAlt: {
    id: 'course-authoring.textbooks.form.upload-button.alt',
    defaultMessage: 'chapter-upload-button',
    description: 'Alt text for the upload button in the form',
  },
  deleteButtonTooltip: {
    id: 'course-authoring.textbooks.form.delete-button.tooltip',
    defaultMessage: 'Delete',
    description: 'Tooltip text for the delete button in the form',
  },
  deleteButtonAlt: {
    id: 'course-authoring.textbooks.form.delete-button.alt',
    defaultMessage: 'chapter-delete-button',
    description: 'Alt text for the delete button in the form',
  },
  cancelButton: {
    id: 'course-authoring.textbooks.form.button.cancel',
    defaultMessage: 'Cancel',
    description: 'Text for the cancel button in the form',
  },
  saveButton: {
    id: 'course-authoring.textbooks.form.button.save',
    defaultMessage: 'Save',
    description: 'Text for the save button in the form',
  },
  uploadModalTitle: {
    id: 'course-authoring.textbooks.form.upload-modal.title',
    defaultMessage: 'Upload a new PDF to “{courseName}”',
    description: 'Title for the upload modal in the form',
  },
  uploadModalDropzoneText: {
    id: 'course-authoring.textbooks.form.upload-modal.dropzone-text',
    defaultMessage: 'Drag and drop your PDF file here or click to upload',
    description: 'Text for the dropzone in the upload modal',
  },
  uploadModalHelperText: {
    id: 'course-authoring.textbooks.form.upload-modal.help-text',
    defaultMessage: 'File must be in PDF format',
    description: 'Helper text for the upload modal',
  },
  uploadModalFileInvalidSizeText: {
    id: 'course-authoring.textbooks.form.upload-modal.file-size-invalid-text',
    defaultMessage: 'File size must be less than {maxSize}MB.',
    description: 'Error message for invalid file size in the upload modal',
  },
};

export default descriptions;
